import { type BBKNavbarOpt } from '@bbkAdminComponents/app-layout/nav/bbk-navbar-opt';

export class BbkNavBarHelper {
  private static buildListOfPaths(opts: BBKNavbarOpt[]): string[] {
    return opts.flatMap((o) => {
      let paths: string[] = [];
      if (o.linkTo) paths.push(o.linkTo);
      if (o.subItems) paths = paths.concat(this.buildListOfPaths(o.subItems));

      return paths;
    });
  }

  static isActive(opt: BBKNavbarOpt, currentPath: string): boolean {
    const paths = this.buildListOfPaths([opt]);
    const regExp = new RegExp(currentPath);
    return paths.some((x) => regExp.test(x));
  }
}
